/** @format */
import { useEffect } from 'react';
import './index.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/HomePage';
import setupInterceptors from './setupInterceptors';
import RequireRole     from 'components/requireRole';
import Dashboard from './pages/Dashboard';
import SignIn from 'pages/SignIn';
import VendorsOverview from 'pages/VendorOverview';
import CustomerDirectoryPage from 'pages/CustomerDirectoryPage';
import AgentFormPage from 'pages/AgentFormPage';
import AffiliatePerformance from 'pages/AffiliatePerformance';
import PasswordResetPage from 'pages/PasswordResetPage';
import CampaignOverview from 'pages/CampaignOverview';
import Users from 'pages/Users';

import Leaderboard from 'pages/Leaderboard';
import UpdatePasswordPage from 'pages/UpdatePasswordPage';
import FormPage from 'pages/FormPage';


function App() {
  useEffect(() => {
    setupInterceptors(); // Set up Axios interceptors on app load
  }, []);
  return (
    <Router>
      <Routes>
        <Route path='/' element={<LandingPage />} />
        <Route
          path='/affiliates-performance'
          element={<AffiliatePerformance />}
        />
 
       
        

        <Route element={<RequireRole allowed={['root_user', 'admin', 'custo', 'root_custo']} />}   // ⬅️ who may pass
        > <Route path='/forms' element={<FormPage />} />
          </Route>
       
       
         
       
        <Route path='/customers' element={<CustomerDirectoryPage />} />
        <Route path='/reset-password' element={<PasswordResetPage/>} />

       
      
        <Route path='/leaderboard' element={<Leaderboard />} />
        <Route path='/Signin' element={<SignIn />} />
        <Route path='/admin/leaderboard' element={<Leaderboard />} />
      
           <Route path='/vendors' element={<VendorsOverview />} />
          
      
      

      
       
        <Route path='/dashboard' element={<Dashboard />} />
    
        <Route path='/campaign' element={<CampaignOverview />} />
      
   
      
        <Route path='/update-password' element={<UpdatePasswordPage />} />
    

        <Route path='agent/forms' element={<AgentFormPage />} />

      
         <Route path='/Users' element={<Users />} />
   
      
      </Routes>
    </Router>
  );
}

export default App;
